export default function TraveledCard({ metric, idx, userdetails }) {
  // let metric={metric}
  //  className="p-4 rounded-lg shadow-lg bg-white  sm:w-[200px] md:w-[270px] "
  // className="bg-white p-4 w-[48%] md:w-[30%] lg:w-[27%] xl:w-[23.5%] rounded-lg shadow-lg items-center "    >

  return (
    <div
      key={idx}
      className={`p-4 rounded-lg shadow-lg bg-white ${userdetails ? "sm:w-[48%] md:w-[32%]" : "w-full sm:w-[31.5%]"}`}
    >
      <div className="flex justify-between items-center">
        <div>
          <p className="xl:text-sm sm:text-xs font-public font-bold text-gray-500">{metric.label}</p>
          <p className="xl:text-xl sm:text-lg font-public font-bold text-gray-900">
            {metric?.value}
            {/* {alert(metric?.value)} */}
          </p>
        </div>
        <div>
          <span>{metric.icon}</span>
        </div>
      </div>
    </div>
  );
}
